import { useState, useEffect } from "react";
import "../index.css";
//import { type RuleTypes } from "../types/ruleTypes";
import buttonBackground from "../assets/button_background_blue.webp";

interface ValidationError {
  title: string;
  message: string;
}

interface WatcherFormNameAndSportProps {
  sportsMetadata: Record<string, unknown>;
  formState: number;
  setFormState: React.Dispatch<React.SetStateAction<number>>;
  ruleName: string;
  setRuleName: React.Dispatch<React.SetStateAction<string>>;
  setSportSelection: (newState: number) => void;
  sportSelectionId: number;
  ruleType: number;
  setRuleType: (n: number) => void;
  inEditMode?: boolean;
}

const PRO_REQUIRED_IDS = new Set(["4", "5"]);
const PREMIUM_REQUIRED_IDS = new Set(["8", "9"]);
const PROPS_COMING_SOON: Record<string, string> = {
  S1: "Props support for NBA and NCAAB is coming in October, just in time for the basketball season!",
  S2: "Props support for NBA and NCAAB is coming in October, just in time for the basketball season!",
  // S3: "Props support for Hockey is coming in September!",
  // // "S5": "Props support for NFL and NCAAF is coming in August, just in time for the football season!",
  // "S6": "Props support for NFL and NCAAF is coming in August, just in time for the football season!",
};
const PROPS_RULE_TYPE_IDS = new Set([4, 5]);

export default function WatcherFormNameAndSport({
  sportsMetadata,
  formState,
  setFormState,
  ruleName,
  setRuleName,
  setSportSelection,
  sportSelectionId,
  ruleType,
  setRuleType,
  inEditMode = false,
}: WatcherFormNameAndSportProps) {
  //   const [innerSportSelectionId, setInnerSportSelectionId] =
  //     useState(sportSelectionId);
  // Use parent's ruleName directly instead of local state to prevent losing data on remount
  const [validationError, setValidationError] =
    useState<ValidationError | null>(null);
  const [comingSoonVisible, setComingSoonVisible] = useState(false);
  const isPro = (() => {
    const sub = localStorage.getItem("subscription_name") || "";
    const lower = sub.toLowerCase();
    return lower.includes("pro") || lower.includes("premium");
  })();
  const isPremium = (() => {
    const sub = localStorage.getItem("subscription_name") || "";
    return sub.toLowerCase().includes("premium");
  })();
  const conference_keys = Object.keys(
    (sportsMetadata as Record<string, unknown>)["sports_metadata"] as Record<
      string,
      unknown
    >,
  );
  const sorted_keys = conference_keys.sort();
  const [sortedIndex, setSortedIndex] = useState(sportSelectionId);
  const [ruleTypeId, setRuleTypeId] = useState(ruleType);

  // Update sortedIndex when sportSelectionId prop changes
  useEffect(() => {
    setSortedIndex(sportSelectionId);
  }, [sportSelectionId]);

  // Update ruleTypeId when ruleType prop changes (e.g. after rule data loads in edit mode)
  useEffect(() => {
    setRuleTypeId(ruleType);
  }, [ruleType]);

  // const [sportLabel, setSportLabel] = useState<string>(
  //   sportSelectionId === -1
  //     ? ""
  //     : ((
  //         (
  //           (sportsMetadata as Record<string, unknown>)[
  //             "sports_metadata"
  //           ] as Record<string, unknown>
  //         )[sportSelectionId.toString()] as Record<string, unknown>
  //       )["name"] as string),
  // );

  const sportsMetadataObj = (sportsMetadata as Record<string, unknown>)[
    "sports_metadata"
  ] as Record<string, unknown>;
  const ruleTypeObj = (sportsMetadata as Record<string, unknown>)[
    "rule_types"
  ] as Record<string, unknown>;

  const sports_list_for_selector: Array<{ label: string; value: string }> = [];
  for (const key of conference_keys) {
    sports_list_for_selector.push({
      label: (sportsMetadataObj[key] as Record<string, unknown>)[
        "name"
      ] as string,
      value: key,
    });
  }

  const handleNext = () => {
    if (ruleName.length === 0 && sortedIndex === -1) {
      setValidationError({
        title: "Missing Information",
        message: "Please enter a rule name and select a sport to continue.",
      });
      return;
    }
    if (ruleName.length === 0) {
      setValidationError({
        title: "Rule Name Required",
        message: "Please enter a name for your rule.",
      });
      return;
    }
    if (sortedIndex === -1) {
      setValidationError({
        title: "Sport Required",
        message: "Please select a sport to continue.",
      });
      return;
    }
    // ruleName is already in parent state, no need to set it again
    setSportSelection(sortedIndex);
    setFormState(formState + 1);
  };

  const getSportId = (idx: number): string =>
    idx === -1
      ? ""
      : (((sportsMetadataObj[idx.toString()] as Record<string, unknown>)?.[
          "id"
        ] as string) ?? "");

  const currentSportId = getSportId(sortedIndex);
  const comingSoonMessage = PROPS_COMING_SOON[currentSportId] ?? null;
  const isPropsBlocked =
    comingSoonMessage !== null && PROPS_RULE_TYPE_IDS.has(ruleTypeId);

  const updateRuleTypeValue = (value: string) => {
    const index = parseInt(value);
    setRuleTypeId(index);
    setRuleType(index);
    if (
      PROPS_COMING_SOON[currentSportId] !== undefined &&
      PROPS_RULE_TYPE_IDS.has(index)
    )
      setComingSoonVisible(true);
  };

  const updateSportValue = (value: string) => {
    const index = parseInt(value);
    const sportId =
      ((sportsMetadataObj[value] as Record<string, unknown>)?.[
        "id"
      ] as string) ?? "";
    setSortedIndex(index);
    if (
      PROPS_COMING_SOON[sportId] !== undefined &&
      PROPS_RULE_TYPE_IDS.has(ruleTypeId)
    )
      setComingSoonVisible(true);
  };

  //   const SetToGame = () => {
  //     setRuleType(RuleType.GAME);
  //   };

  //   const SetToGameProps = () => {
  //     setRuleType(RuleType.GAME_PROP);
  //   };

  //   const SetToPlayerProps = () => {
  //     setRuleType(RuleType.PLAYER_PROP);
  //   };

  return (
    <>
      <div
        style={{ padding: "0 10px", display: "flex", justifyContent: "center" }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: 10,
            maxWidth: 800,
          }}
        >
          <div style={{ minWidth: 200 }}>
            <div
              className=" border_radius"
              style={{
                marginTop: 10,
              }}
            >
              <div>
                <div
                  className=" border_radius center_me"
                  style={{
                    marginTop: 10,
                    paddingLeft: 15,
                    paddingRight: 15,
                    marginBottom: 15,
                  }}
                >
                  <h2
                    className="font_family_base text_green center_me "
                    style={{
                      fontSize: 28,
                      fontWeight: "bold",
                      marginBottom: 10,
                      textAlign: "center",
                      marginTop: 8,
                    }}
                  >
                    {inEditMode ? "Editing Rule..." : "Create A New Rule"}
                  </h2>
                </div>

                <div
                  style={{
                    marginBottom: 15,
                    display: inEditMode ? "none" : undefined,
                  }}
                >
                  <select
                    className="font_family_base background_3 border_radius has_border"
                    value={ruleTypeId.toString()}
                    onChange={(e) => updateRuleTypeValue(e.target.value)}
                    style={{
                      padding: "12px 16px",
                      fontSize: 16,
                      color: "#FFF",
                      width: "100%",
                      boxSizing: "border-box",
                    }}
                  >
                    {Object.keys(ruleTypeObj).map((item) => {
                      const name = (
                        ruleTypeObj[item] as Record<string, unknown>
                      )["name"] as string;
                      const needsPro = PRO_REQUIRED_IDS.has(item) && !isPro;
                      const needsPremium =
                        PREMIUM_REQUIRED_IDS.has(item) && !isPremium;
                      return (
                        <option
                          key={item}
                          value={item}
                          disabled={
                            name.includes("Coming Soon") ||
                            needsPro ||
                            needsPremium
                          }
                        >
                          {needsPremium
                            ? `${name} (Premium Required)`
                            : needsPro
                              ? `${name} (Pro Required)`
                              : name}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
            </div>

            <div className=" border_radius">
              <div>
                <div style={{ marginBottom: 15 }}>
                  <select
                    className="font_family_base background_3 border_radius has_border"
                    value={sortedIndex === -1 ? "" : sortedIndex.toString()}
                    onChange={(e) => updateSportValue(e.target.value)}
                    style={{
                      padding: "12px 16px",
                      fontSize: 16,
                      color: "#FFF",
                      width: "100%",
                      boxSizing: "border-box",
                    }}
                  >
                    <option value="">Select your Sport</option>
                    {sorted_keys.map((item) => (
                      <option key={item} value={item}>
                        {
                          (sportsMetadataObj[item] as Record<string, unknown>)[
                            "name"
                          ] as string
                        }
                      </option>
                    ))}
                  </select>
                </div>
                <div style={{ marginTop: 10 }}>
                  <input
                    className="font_family_base"
                    type="text"
                    autoFocus
                    style={{
                      backgroundColor: "white",
                      padding: "12px 15px",
                      borderRadius: 20,
                      marginBottom: 15,
                      fontSize: 16,
                      width: "100%",
                      boxSizing: "border-box",
                    }}
                    placeholder="Rule Name"
                    value={ruleName}
                    onChange={(e) => setRuleName(e.target.value)}
                  />
                </div>
              </div>
            </div>

            {/* Next Button */}
            <div className="center_me" style={{ marginTop: 10 }}>
              <button
                onClick={handleNext}
                disabled={isPropsBlocked}
                className="my-form-button button-base button-3d font_family_base"
                style={{
                  marginTop: "5px",
                  marginBottom: "5px",
                  backgroundImage: `url(${buttonBackground})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  color: "white",
                  fontWeight: 700,
                  opacity: isPropsBlocked ? 0.4 : 1,
                  cursor: isPropsBlocked ? "not-allowed" : "pointer",
                }}
              >
                Next →
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Coming Soon Modal */}
      {comingSoonVisible && (
        <div
          onClick={() => setComingSoonVisible(false)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            zIndex: 1000,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="background_2 border_radius"
            style={{
              padding: 30,
              maxWidth: 400,
              width: "90%",
              textAlign: "center",
              border: "1px solid #333",
            }}
          >
            <h3
              className="font_family_base"
              style={{ color: "#fff", marginBottom: 15, fontSize: 20 }}
            >
              Coming Soon 🏈
            </h3>
            <p
              className="font_family_base"
              style={{
                color: "#ccc",
                marginBottom: 25,
                fontSize: 16,
                lineHeight: 1.5,
              }}
            >
              {comingSoonMessage}
            </p>
            <button
              onClick={() => setComingSoonVisible(false)}
              className="my-form-button-wide button-base button-3d font_family_base"
              style={{
                backgroundImage: `url(${buttonBackground})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                color: "white",
                fontWeight: 700,
                padding: "12px 24px",
              }}
            >
              Got It
            </button>
          </div>
        </div>
      )}

      {/* Validation Error Modal */}
      {validationError && (
        <div
          onClick={() => setValidationError(null)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            zIndex: 1000,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="background_2 border_radius"
            style={{
              padding: 30,
              maxWidth: 400,
              width: "90%",
              textAlign: "center",
              border: "1px solid #333",
            }}
          >
            <h3
              className="font_family_base"
              style={{
                color: "#fff",
                marginBottom: 15,
                fontSize: 20,
              }}
            >
              {validationError.title}
            </h3>
            <p
              className="font_family_base"
              style={{
                color: "#ccc",
                marginBottom: 25,
                fontSize: 16,
                lineHeight: 1.5,
              }}
            >
              {validationError.message}
            </p>
            <button
              onClick={() => setValidationError(null)}
              className="my-form-button-wide button-base button-3d font_family_base"
              style={{
                backgroundImage: `url(${buttonBackground})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                color: "white",
                fontWeight: 700,
                padding: "12px 24px",
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </>
  );
}
